// @generated by tools/docgen — do not edit.
// Source: docs/examples/streaming_list.md

import React from 'react';
import { StreamingListDemo } from './demo';
import {
  ExampleLayout,
  ExampleSection,
  ExampleSectionHeading,
  ExampleDescription,
  ExampleClientBadge,
} from '../../components/ExampleLayout';
import { SourceFile } from '../../components/SourceFile';

export function StreamingListPage() {
  return (
    <ExampleLayout title="Streaming list updates" demo={<StreamingListDemo />}>
      <ExampleSection position="first">
        <ExampleDescription>
          This example shows updates that no client asked for: a background timer appends one number to rx[list[int]] every tick, entirely independent of any client action. Each tick sends one small update — the message size never grows with how many items the list already holds.
        </ExampleDescription>
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-streaming-list-backend">
        <ExampleSectionHeading id="examples-streaming-list-backend">
          Backend
        </ExampleSectionHeading>
        <SourceFile path="streaming_list/channels.py" />
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-streaming-list-frontend" position="last">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <ExampleSectionHeading id="examples-streaming-list-frontend">
            Frontend
          </ExampleSectionHeading>
          <ExampleClientBadge />
        </div>
        <SourceFile path="streaming_list/demo.tsx" />
      </ExampleSection>
    </ExampleLayout>
  );
}

export default StreamingListPage;
